import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  InputField,
  SelectField,
  Button,
  TextSmall,
} from '../../components';
import * as Icons from '@mui/icons-material';

const PreForm = (props) => {
  const {
    dimensions,
    preForm,
    setPreForm,
    openDialogDeleteData,
  } = props;

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;

  return (
    <FormRow justifyContent='center'>
      <FormColumn width={width} padding={10}>
        <FormRow>
          <InputField
            title={`ID ${getDic("evento")}`}
            value={preForm.eventId}
            onChange={v => setPreForm({ ...preForm, eventId: v })}
          />
        </FormRow>
        <FormRow>
          <SelectField
            title={`${getDic("sistema")}`}
            value={preForm.system}
            onChange={v => setPreForm({ ...preForm, system: v })}
            menuItens={[
              { value: '', text: getDic("selecione") },
              { value: 'inteegra_eventos', text: 'Inteegra Eventos' },
              { value: 'mice', text: 'Mice' },
              { value: 'mice_sant', text: 'Mice Sant' },
            ]}
          />
        </FormRow>
        <FormRow paddingTop={20} justifyContent='center'>
          <Button
            width={width - 20}
            onPress={() => openDialogDeleteData()}
          >
            <FormRow justifyContent='center'>
              <FormColumn justifyContent='center' paddingRight={5}>
                <TextSmall color='white' fontWeight='bold'>{`${getDic("deletar")} ${getDic("dados")}`}</TextSmall>
              </FormColumn>
              <Icons.DeleteForever style={{ color: 'white', fontSize: 15 }} />
            </FormRow>
          </Button>
        </FormRow>
      </FormColumn>
    </FormRow>
  )
};

export default PreForm;
